/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProposalResponse } from '../model/proposalResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MyCheckProposalControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param rulesetId 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apply(rulesetId: string, id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<ProposalResponse>;
    public apply(rulesetId: string, id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProposalResponse>>;
    public apply(rulesetId: string, id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProposalResponse>>;
    public apply(rulesetId: string, id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rulesetId === null || rulesetId === undefined) {
            throw new Error('Required parameter rulesetId was null or undefined when calling apply.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apply.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling apply.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProposalResponse>('post',`${this.basePath}/check-rules/${encodeURIComponent(String(rulesetId))}/proposals/${encodeURIComponent(String(id))}/apply`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rulesetId 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public discard(rulesetId: string, id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<ProposalResponse>;
    public discard(rulesetId: string, id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProposalResponse>>;
    public discard(rulesetId: string, id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProposalResponse>>;
    public discard(rulesetId: string, id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rulesetId === null || rulesetId === undefined) {
            throw new Error('Required parameter rulesetId was null or undefined when calling discard.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling discard.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling discard.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProposalResponse>('post',`${this.basePath}/check-rules/${encodeURIComponent(String(rulesetId))}/proposals/${encodeURIComponent(String(id))}/discard`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rulesetId 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getById(rulesetId: string, id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<ProposalResponse>;
    public getById(rulesetId: string, id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProposalResponse>>;
    public getById(rulesetId: string, id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProposalResponse>>;
    public getById(rulesetId: string, id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rulesetId === null || rulesetId === undefined) {
            throw new Error('Required parameter rulesetId was null or undefined when calling getById.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getById.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getById.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProposalResponse>('get',`${this.basePath}/check-rules/${encodeURIComponent(String(rulesetId))}/proposals/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rulesetId 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public latest(rulesetId: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<ProposalResponse>;
    public latest(rulesetId: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProposalResponse>>;
    public latest(rulesetId: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProposalResponse>>;
    public latest(rulesetId: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rulesetId === null || rulesetId === undefined) {
            throw new Error('Required parameter rulesetId was null or undefined when calling latest.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling latest.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProposalResponse>('get',`${this.basePath}/check-rules/${encodeURIComponent(String(rulesetId))}/proposals/latest`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
